import React from "react";
import { useState } from "react";
import PlusIcon from "assets/icons/Plus.svg";
import JobImage from "assets/images/Jobs.png";
import BodyHeader from "../common/BodyHeader";
import ReusableCard from "../common/ReusableCard";
import CustomPagination from "../common/Pagination";
import SearchBar from "../common/SearchBarActivities";
import EmptyActivities from "../common/EmptyActivities";
import { useNavigate } from "react-router-dom";
const DraftJobs = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const resultsPerPage = 10;
  const [jobs, setJobs] = React.useState([
    {
      id: 1,
      title: "Kitchen Faucet Repair",
      jobId: "-",
      address: "-",
      date: "-",
      status: "Draft",
    },
    {
      id: 2,
      title: "Kitchen Faucet Repair",
      jobId: "-",
      address: "-",
      date: "-",
      status: "Draft",
    },
    {
      id: 3,
      title: "Kitchen Faucet Repair",
      jobId: "-",
      address: "-",
      date: "-",
      status: "Draft",
    },
    {
      id: 4,
      title: "Kitchen Faucet Repair",
      jobId: "-",
      address: "-",
      date: "-",
      status: "Draft",
    },
    {
      id: 5,
      title: "Kitchen Faucet Repair",
      jobId: "-",
      address: "-",
      date: "-",
      status: "Draft",
    },
    {
      id: 6,
      title: "Kitchen Faucet Repair",
      jobId: "-",
      address: "-",
      date: "-",
      status: "Draft",
    },
    {
      id: 7,
      title: "Kitchen Faucet Repair",
      jobId: "-",
      address: "-",
      date: "-",
      status: "Draft",
    },
    {
      id: 8,
      title: "Kitchen Faucet Repair",
      jobId: "-",
      address: "-",
      date: "-",
      status: "Draft",
    },
    {
      id: 9,
      title: "Kitchen Faucet Repair",
      jobId: "-",
      address: "-",
      date: "-",
      status: "Draft",
    },
    {
      id: 10,
      title: "Kitchen Faucet Repair",
      jobId: "-",
      address: "-",
      date: "-",
      status: "Draft",
    },
  ]);
  const totalPages = Math.ceil(jobs.length / resultsPerPage);
  return (
    <div className=" max-w-[1440px] m-auto md:py-12 py-8 md:px-6 px-4 ">
      {" "}
      <div className="pt-[70px]">
        <div className="flex flex-col md:gap-12 gap-4">
          <BodyHeader
            title="Draft Jobs"
            description="Continue posting jobs you've started but haven't finished. Edit, complete, or discard drafts anytime."
          >
            {" "}
            {!!jobs && (
              <button
                onClick={() => navigate("/post-job")}
                className="bg-[#3cab5c] text-nowrap flex gap-2 items-center justify-center h-12   w-fit hover:bg-[#3c8f47] text-white  px-3 sm:text-[14px] lg:text-[16px] xl:text-[18px]   py-3 rounded-xl font-medium"
              >
                <img src={PlusIcon} className="w-[14px] h-[14px]"></img> Post a
                job
              </button>
            )}
          </BodyHeader>

          <SearchBar
            label="Search Job"
            placeholder="Search by Job Title or Property"
            select={
              jobs.length
                ? [
                    { label: "Job Status", values: ["A", "B", "C"] },
                    { label: "Category", values: ["A", "B", "C"] },
                    { label: "Sort by", values: ["A", "B", "C"] },
                  ]
                : [{ label: "Sort by", values: ["A", "B", "C"] }]
            }
          ></SearchBar>
        </div>
        {jobs.length ? (
          <div className=" md:py-4 py-2">
            {" "}
            <ReusableCard
              resultsPerPage={10}
              jobs={jobs}
              classGrid="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 "
            ></ReusableCard>
          </div>
        ) : (
          <EmptyActivities
            label="No drafts saved yet."
            description="Started a job post but didn't finish? You'll find it here to pick up where you left off."
            img={JobImage}
            additionalButton={true}
          ></EmptyActivities>
        )}
      </div>
    </div>
  );
};

export default DraftJobs;
